module.exports = __webpack_public_path__ + "zvetseni-prsou_9_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_9_after.jpg
// module id = 1371
// module chunks = 0